import { render, staticRenderFns } from "./Edital.vue?vue&type=template&id=c8f92398&scoped=true&"
import script from "./Edital.vue?vue&type=script&lang=js&"
export * from "./Edital.vue?vue&type=script&lang=js&"
import style0 from "./Edital.vue?vue&type=style&index=0&id=c8f92398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f92398",
  null
  
)

export default component.exports